exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "._1CGHrDMZ0u{display:inline-block;vertical-align:middle}._30t7gr97gF{font-family:museo_sans_cyrl900,PT Sans,Helvetica,Arial,sans-serif;font-size:36px}._1sbH9SaSiG{font-size:14px;margin-top:-5px}", ""]);

// exports
exports.locals = {
	"main": "_1CGHrDMZ0u",
	"number": "_30t7gr97gF",
	"label": "_1sbH9SaSiG"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize&modules&importLoaders=1&localIdentName=[hash:base64:10]!./~/postcss-loader!./~/sass-loader?includePaths[]=%2Fvar%2Fwww%2Fyii%2Fprod.smartprogress%2Fsrc%2Fsass!./src/react/components/BigNumber/BigNumber.scss
// module id = 964
// module chunks = 20 24 30